module.exports = __webpack_public_path__ + "static/assets/4f4d22594d26b423831ddbbc3bf0d8ad.svg";